import * as t from 'io-ts';
import {
  Template,
  Route,
  MySafetyHtmls,
  Offer,
  TopBusesFrom,
  TopOperators,
  LeaveIntentOffer,
  SeoOfferData,
} from '../../../src/pages/runtime-typechecker';

export const OperatorData = t.type({
  id: t.number,
  operatorName: t.string,
  description: t.union([t.string, t.undefined, t.null]),
});
export const CityDataForRoute = t.type({
  id: t.number,
  name: t.string,
  description: t.union([t.string, t.null]),
  url: t.string,
  code: t.string,
  cityBoardingPointsList: t.union([t.array(t.string), t.undefined]),
  cityDropPointsList: t.union([t.array(t.string), t.undefined]),
  otherRoutesFrom: t.array(Route),
  otherRoutesTo: t.array(Route),
  otherRouteOperators: t.array(Route),
});
export type CityDataForRoute = t.TypeOf<typeof CityDataForRoute>;

export const RouteDataForRouteOperator = t.type({
  sourceCityData: CityDataForRoute,
  destinationCityData: CityDataForRoute,
  topBusesFrom: TopBusesFrom,
  offers: t.union([t.undefined, t.array(Offer)]),
  returnRouteOperatorUrl: t.union([t.string, t.null]),
  topOperatorsList: t.array(TopOperators),
});

export const RouteOperatorTemplateDataChecker = t.type({
  rtcAcronym: t.union([t.string, t.undefined, t.null]),
  id: t.number,
  routeId: t.number,
  operatorId: t.number,
  isActive: t.boolean,
  Show404: t.union([t.boolean, t.null, t.undefined]),
  url: t.string,
  urlPhrase: t.string,
  urlPhraseRedirection: t.string,
  description: t.union([t.string, t.null]),
  htmlRefreshDate: t.union([t.string, t.null]),
  created: t.string,
  modified: t.string,
  templateData: Template,
  routeData: RouteDataForRouteOperator,
  operatorData: OperatorData,
  mySafetyHtmls: MySafetyHtmls,
  offers: t.union([t.array(Offer), t.undefined]),
  leaveIntentOffers: t.array(LeaveIntentOffer),
  status: t.string,
  nearbyCitiesSource: t.array(Route),
  nearbyCitiesDestination: t.array(Route),
  seoOfferData: t.array(SeoOfferData),
  schemaInfo: t.union([t.undefined, t.null, t.string]),
  bookingSummary: t.union([t.string, t.null]),
});

export type RouteOperatorData = t.TypeOf<
  typeof RouteOperatorTemplateDataChecker
>;
